import {RootScopeDeclare} from './rootscope-declare';

export const RootScopeData: RootScopeDeclare = {
    pageName: 'Dashboard',
    contentAreaHeight: 500,
    contentHeight: 300,
    leftNavHeight: 500,
    footerHeight: 198,
    screenSize: 'xl',
    selectedLang: 'en_US',
    enablePopup: false,
    isRTL: false,
    serviceBasePath:'https://localhost:8443/lfcws/',
    profileImageUrl: "",
    isCookieBannerClosed: false,
    isAuthenticated: false,
    currentFacility: {},
    lastSelectedConsole: '',
    lastSelectedFacility: '',
    popupData: {},
    managerData: {},
    countryList:new Map(),
    consoleRights: new Map(),
    currentlySelectedFacilityId: '',
    translationsLoaded: false,
    isPageHasUnsavedChanges: false,
    unsavedChangesPopupData: {},
    showUnSavedChangesModal: false,
    isFromFacilitySelection: '',
    pathToNavigate: '',
    pathToNavigateQueryParam:null,
    totalPendingSoftwareUpdates:0,
    ssoPartsUrl: 'https://external.lifefitness.com',
    deviceType: '',
    showDoorBanner: false,
    userAccessingCountryCode: 'sg',
    isTronCountry: false,
    isIpUsbased: false,
    userRequestedURL: window.location.href,
    currentUser:{
        userId:0,
        emailAddress:'',
        enabled:false,
        nickName:'',
        preferredLanguage:'',
        managerType:'',
        acceptTnC:true,
        firstName:'',
        lastName:'',
        preferredUnit:'',
        isSSOFederated:false,
        displayName:'',
        zendeskToken:'',
        profileImageUrl:'',
        isSubscriptionAccepted:true,
       resetPassword:false,
       hasNewPasswordPolicy:'true',
       isASBU:false,
       tokenExpiryAt:''
    },
    announcementModals:[],
    softwarePendingCountList:{},
    showLFODTooltip: true,
    showLFODPremiumTooltip: true,
    showNewPermissionTooltip: true,
    showVideoLibraryTooltip: true,
    showVideoAddDescTooltip: true,
    showAttractScreenPopup: true,
    showFacilitySetupPopup: true,
    currentUrl:'',
    previousUrl:'',
    showCustomModal: false,  
    customPopupData: {}
};
